module.exports = __webpack_public_path__ + "media/images/icon-svg/phone-3d1bbc68324d50e8c8c9d08fc5be1ef3.svg";